import React from 'react'
import Button from '../../../../components/buttons/buttons.component'
import StyledFlexContainer from '../../../../components/containers/flex-container.component.jsx'
import { SelectInput } from '../../../../components/form-components'
import { Formik } from 'formik'
import PointsExchangeService from './../../../../services/points-exchange.service'

const buttonStyle = {
	marginBottom: '24rem'
}

class PlanaltoContent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			points: '',
			originOptions: [],
			destinationOptions: []
		}

		this.formikRender = formikRender.bind(this)
		this.updatePoints = updatePoints.bind(this)
		this.resetDestination = resetDestination.bind(this)
		this.loadOriginOptions = loadOriginOptions.bind(this)
		this.loadDestinationOptions = loadDestinationOptions.bind(this)
	}

	componentWillMount() {
		this.loadOriginOptions()
	}

	render() {
		return (
			<React.Fragment>
				<Formik
					ref={'form'}
					initialValues={initialValues}
					render={this.formikRender}
				/>
				<div className={'center'}>
					<PointsMessage points={this.state.points} />
					<Button
						primary
						type={'button'}
						onClick={openPlanaltoEcommerce}
						style={buttonStyle}>
						Troque pontos por passagens
					</Button>
				</div>
			</React.Fragment>
		)
	}
}

const PointsMessage = ({ points }) =>
	points ? (
		<h3 className={'orange semi-bold'}>
			A partir de <span className={'blue'}>{points}</span> pontos Muviflex
		</h3>
	) : (
		<h3 className={'orange semi-bold'}>
			Escolha origem e destino e simule o valor em pontos!
		</h3>
	)

const initialValues = {
	origin: '',
	destination: ''
}

function updatePoints(points) {
	this.setState({ points })
}

function resetDestination(origin) {
	if (origin == this.previousOrigin) return

	this.previousOrigin = origin
	this.refs.form.setFieldValue('destination', '')

	this.loadDestinationOptions(origin)
}

function openPlanaltoEcommerce() {
	const url =
		'https://e-commerce.passagensweb.net/esipe/Venda/planaltotransportes/Principal'

	window.open(url)
}

function formikRender(props) {
	return (
		<StyledFlexContainer>
			<SelectInput
				id="origin"
				className="col-6"
				label="Saindo de"
				placeholder="Selecione ..."
				onValueChange={this.resetDestination}
				options={this.state.originOptions}
				multi={false}
				{...props}
			/>
			<SelectInput
				id="destination"
				className="col-6"
				label="Chegando em"
				placeholder="Selecione ..."
				onValueChange={this.updatePoints}
				options={this.state.destinationOptions}
				multi={false}
				{...props}
			/>
		</StyledFlexContainer>
	)
}

function loadOriginOptions() {
	PointsExchangeService.listOrigin().then(({ data }) => {
		const originOptions = data.map(origin => ({
			label: origin,
			value: origin
		}))
		this.setState({ originOptions })
	})
}

function loadDestinationOptions() {
	const origin = this.previousOrigin

	PointsExchangeService.searchDestination({ origin }).then(({ data }) => {
		const destinationOptions = data.map(({ destinationCity, points }) => ({
			label: destinationCity,
			value: (+points).toLocaleString('pt-br')
		}))
		this.setState({ destinationOptions })
	})
}

export default PlanaltoContent
